import * as INR from "../INR.ts";
import * as libLocation from "../lib/location.ts";
import { hasValidatedOfferCode } from "./journey-state.ts";

const HOMEHUB_AUTH_CONTEXT_PARAM = "homehub";

export function getHomeHubAuthUrl(url: string): string {
  return `${url}?${HOMEHUB_AUTH_CONTEXT_PARAM}=1`;
}

/**
 * True while the customer is authenticating as part of a Home Hub activation.
 * The activation journey must own an offer code and the current URL must carry
 * the Home Hub marker, so an ordinary sign-in is never rerouted into the journey.
 */
export function isHomeHubAuthenticationContext(): boolean {
  return hasValidatedOfferCode()
    && libLocation.getURLParam(HOMEHUB_AUTH_CONTEXT_PARAM) === "1";
}

export function getHomeHubAuthTemplateContext() {
  const homehubActivation = isHomeHubAuthenticationContext();
  return {
    homehubActivation,
    homehubSignInUrl: homehubActivation ? getHomeHubAuthUrl(INR.URL.FW2_SIGNIN) : INR.URL.FW2_SIGNIN,
    homehubSignUpUrl: homehubActivation ? getHomeHubAuthUrl(INR.URL.FW2_SIGNUP) : INR.URL.FW2_SIGNUP
  };
}

/**
 * Where to send the customer after Home Hub-aware sign-in, sign-up, family
 * creation, or terms acceptance. Review re-checks every prerequisite itself, so
 * this only has to hand the journey back to it.
 */
export function getHomeHubContinuationUrl(): string|null {
  return isHomeHubAuthenticationContext() ? INR.URL.HOMEHUB_ACTIVATION_REVIEW : null;
}
